import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Autocomplete } from 'seagull';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import { billingHubHeaderTextsPath, getGroupedAgreementOptions, toAdHocOptions } from '~/pages/GlobalBillingHub/GlobalBillingHub.utils';
import { useFetchRelationshipSummaries } from '~/pages/GlobalBillingHub/hooks/useFetchRelationshipSummaries';
import styles from './AgreementForCustomerSelect.module.scss';
export function AgreementForCustomerSelect(param) {
    let { customerId, selectedRelationshipId, onChange, testId = 'agreement-for-customer-select', bi = {
        name: 'agreement_for_customer_select'
    }, className, label } = param;
    const { t: headerTexts } = useLocaleKeys(billingHubHeaderTextsPath);
    const isMobileDevice = useIsMobileForHomePage();
    const { summaries } = useFetchRelationshipSummaries();
    const groupedOptions = useMemo(()=>getGroupedAgreementOptions(summaries, customerId), [
        summaries,
        customerId
    ]);
    const relationshipOptions = useMemo(()=>[
            ...groupedOptions.agreements,
            ...toAdHocOptions(groupedOptions.adHocRelationships, headerTexts)
        ], [
        groupedOptions
    ]);
    const selected = relationshipOptions.find((o)=>o.id === selectedRelationshipId);
    if (selected == null) return null;
    const hasAdHoc = groupedOptions.adHocRelationships.length > 0;
    const hasAgreements = groupedOptions.agreements.length > 0;
    return /*#__PURE__*/ _jsx(Autocomplete, {
        bi: bi,
        forcePopupIcon: true,
        disableClearable: true,
        className: cn(styles.autocomplete, {
            [styles.autocompleteMobile]: isMobileDevice
        }, className),
        testId: testId,
        options: relationshipOptions,
        value: selected,
        getOptionLabel: (option)=>option.text,
        textFieldProps: {
            label: label !== null && label !== void 0 ? label : headerTexts.agreementLabel(),
            placeholder: headerTexts.noAgreements()
        },
        dividers: hasAgreements && hasAdHoc ? [
            groupedOptions.agreements.length
        ] : undefined,
        onChange: (_, newOption)=>{
            var _ref;
            if (typeof newOption === 'string' || Array.isArray(newOption)) return;
            onChange((_ref = newOption === null || newOption === void 0 ? void 0 : newOption.id) !== null && _ref !== void 0 ? _ref : '');
        }
    });
}
